Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing;
  var container = {
    flexDirection: 'row'
  };
  if (bp.not([bp.mobile_xl, bp.tablet, bp.desktop])) {
    container.flexDirection = 'column';
  }
  var buttonGroup = {
    flex: 1,
    flexDirection: 'row',
    maxWidth: _styles.STYLES.grid.maxInputWidth
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m])) {
    buttonGroup.flexDirection = 'column';
  }
  var buttonGroupItem = {};
  if (bp.is([bp.mobile_l])) {
    buttonGroupItem.flex = 1;
  }
  var modalCloseButtonContainer = {
    flexGrow: 1
  };
  var modalCloseButtonText = Object.assign({}, _reactNative.StyleSheet.absoluteFillObject);
  var modalButtons = {
    flexDirection: 'row',
    marginBottom: spacing.l
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m, bp.mobile_l])) {
    modalButtons.flexDirection = 'column';
  }
  var styles = _reactNative.StyleSheet.create({
    container: container,
    buttonGroup: buttonGroup,
    buttonGroupItem: buttonGroupItem,
    modalCloseButtonContainer: modalCloseButtonContainer,
    modalCloseButtonText: modalCloseButtonText,
    modalButtons: modalButtons
  });
  return {
    styles: styles
  };
};